import { render } from "./SpColumn.vue?vue&type=template&id=6051a5c4"
import script from "./SpColumn.vue?vue&type=script&lang=js"
export * from "./SpColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__